"use strict";

exports.__esModule = true;
exports.errorFactory = errorFactory;
/**
 * error factory
 */
function errorFactory({
  error,
  language
} = {}) {
  return error;
}